import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { TenantContinuousUpdateComponent } from './tenant-continuous-update.component';
import { ViewInstanceComponent } from './view-instance/view-instance.component';
import { ViewInstanceDetailsComponent } from './view-instance-details/view-instance-details.component';
import { UpdateBuildComponent } from './update-build/update-build.component';
import { ComponentUpdateComponent } from './component-update/component-update.component';
import { ExternalTenantGuard } from 'src/app/services/util/external-tenant.guard';

const routes: Routes = [
  {
    path: '',
    component: TenantContinuousUpdateComponent,
    title: 'Continuous Update',
    canActivate: [ExternalTenantGuard]
  },
  {
    path: 'blueprints/:blueprintId',
    component: ViewInstanceComponent,
    canActivate: [ExternalTenantGuard]
  },
  {
    path: ':solutionId/:blueprintId/instance/:instanceId/component',
    component: ComponentUpdateComponent,
    canActivate: [ExternalTenantGuard]
  },
  {
    path: ':solutionId/:changeId/:instanceId/update',
    component: UpdateBuildComponent,
    canActivate: [ExternalTenantGuard]
  },
  {
    path: ':solutionId/:blueprintId/instance/:instanceId',
    component: ViewInstanceDetailsComponent,
    canActivate: [ExternalTenantGuard]
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TenantContinuousUpdateRoutingModule {
}
